// extracted by mini-css-extract-plugin
module.exports = {"container":"footer_container__OJLlx","text":"footer_text__XPcED"};